import { GetUserPostsFilterRequest } from '../../../types/post/requests/GetUserPostsFilterRequest'
import { axios, Response } from '../index'
import { Post } from './get-post-by-id'

const getUserFeed = (
  filterRequest?: GetUserPostsFilterRequest
): Response<Post[]> => {
  let baseUrl = `/v2/personas/posts`

  /* Applying the filter params */

  if (filterRequest) {
    const filterRequestRecordStringAndString =
      filterRequest as unknown as Record<string, string>

    const searchParams = new URLSearchParams()

    for (const [key, value] of Object.entries(
      filterRequestRecordStringAndString
    )) {
      if (value !== undefined && key !== undefined) {
        searchParams.append(key, value.toString())
      }
    }

    // Adicione outras condições para adicionar outros campos à coleção de parâmetros existente

    baseUrl += `?${searchParams.toString()}`
  }

  return axios.get(baseUrl, {})
}

export default getUserFeed
